import { Stack, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { BalanceBreakdownList } from "web_myplann/Finances/Components/BalanceBreakdownList";
import { BalanceBreakdownRow } from "web_myplann/Finances/Components/BalanceBreakdownRow";
import type { BalanceBreakdownEntry } from "web_myplann/Finances/Types/BalanceBreakdownEntry";
import { SectionHeader } from "web_myplann/Shared/Components/SectionHeader";

type Props = {
	sectionTitle: string;
	icon: LucideIcon;
	iconColor: string;
	totalLabel: string;
	totalAmount: number;
	totalColor: string;
	entries: BalanceBreakdownEntry[];
};

export const BalanceBreakdownSection: FC<Props> = ({
	sectionTitle,
	icon: Icon,
	iconColor,
	totalLabel,
	totalAmount,
	totalColor,
	entries,
}) => {
	const theme = useTheme();

	return (
		<>
			<SectionHeader title={sectionTitle} />
			<Stack bgcolor={theme.palette.background.paper}>
				<BalanceBreakdownRow
					variant="total"
					icon={<Icon size={theme.iconSize.md} color={iconColor} />}
					label={totalLabel}
					amount={totalAmount}
					amountColor={totalColor}
					isLast={entries.length === 0}
				/>
				<BalanceBreakdownList entries={entries} />
			</Stack>
		</>
	);
};
